import React, { useState } from "react";
import { Dialog, DialogTitle } from "@mui/material";

import { Switch, TextField as MaterialTextInput } from "@mui/material";

import { SimpleForm, TextInput, useNotify, useRefresh, useDataProvider, useRedirect } from "react-admin";

import { Accordion, CustomToolbar } from "./utils";

const CloneComponentVersionsDialog = ({ open, record, resource, route, close }) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const dataProvider = useDataProvider();

  const redirect = useRedirect();

  const [versionName, setVersionName] = useState("");

  const [componentName, setComponentName] = useState("");

  const [isNewComponent, setisNewComponent] = useState(false);

  const onSubmit = e => {
    const baseUrl = `${resource}/${record.id}`;

    const url = isNewComponent ? `${baseUrl}/component/clone` : `${baseUrl}/clone`;

    const data = isNewComponent ? { componentName: componentName, versionName: versionName } : { name: versionName };

    const cloneType = !isNewComponent ? "Версията" : "Компонента";

    return dataProvider
      .create(url, {
        data: data,
        meta: { useFormData: false },
      })
      .then(response => {
        close();
        if (!isNewComponent) {
          refresh();
        } else {
          redirect(`/custom-components-cms/${response?.data?.id}`);
        }

        notify(`${cloneType} е клониран${cloneType === "Версията" ? "a" : ""} успешно!`, { type: "success" });
      })
      .catch(error => {
        notify(`${cloneType} не е клониран${cloneType === "Версията" ? "a" : ""}!`, { type: "error" });
        refresh();
        close();
      });
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
    >
      <DialogTitle>{`Клонирай версия с № ${record.id}, име:  ${record.name}`}</DialogTitle>

      <SimpleForm
        onSubmit={onSubmit}
        toolbar={<CustomToolbar close={close} />}
      >
        <label>
          Нов компонент
          <Switch
            onChange={e => setisNewComponent(e.target.checked)}
            checked={isNewComponent}
          />
        </label>

        <TextInput
          fullWidth
          required
          source={isNewComponent ? "componentName" : "name"}
          label="Име на нова версия"
          onChange={e => setVersionName(e.target.value)}
        />
        <Accordion open={isNewComponent}>
          <MaterialTextInput
            fullWidth
            required={isNewComponent}
            label="Име на нов компонент"
            value={componentName}
            onChange={e => setComponentName(e.target.value)}
          ></MaterialTextInput>
        </Accordion>
      </SimpleForm>
    </Dialog>
  );
};
export default CloneComponentVersionsDialog;
